<template>
  <div class="app-container">
    <div class="filter-container">
      <el-card class="custom-card" shadow="never">
        <el-input
          v-model="listQuery.userName"
          placeholder="用户名"
          style="width: 200px;"
          class="filter-item"
          @change="handleChange"
          @keyup.enter.native="handleFilter" />
        <el-date-picker
          v-model="listQuery.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          class="filter-item"
          placeholder="选择开始日期" />
        <el-date-picker
          v-model="listQuery.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          class="filter-item"
          placeholder="选择结束日期" />
        <el-button
          v-waves
          round
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilter">{{ $t('table.search') }}</el-button>
      </el-card>

    </div>
    <div class="filter-container">
      <el-table
        v-loading="listLoading"
        :key="tableKey"
        :data="list"
        fit
        stripe
        highlight-current-row
        style="width: 100%;">
        <el-table-column
          type="index"
          width="100"
          align="center" />
        <el-table-column
          label="用户名"
          prop="Identity"
          sortable
          align="center"
          width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.UserName">{{ scope.row.UserName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="金额/元"
          align="center"
          width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.AccountDetail">{{ scope.row.AccountDetail.Rmb }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="备注"
          align="center"
          min-width="100%">
          <template slot-scope="scope">
            <span v-if="scope.row.AccountDetail">{{ scope.row.AccountDetail.Memo }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          label="退款时间"
          width="300px"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.AccountDetail">{{ scope.row.AccountDetail.AddTime }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <el-card class="custom-card" shadow="never">
        <el-pagination
          v-show="total>0"
          :current-page="listQuery.pageIndex"
          :page-sizes="[10,20,50,100]"
          :page-size="listQuery.pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </el-card>
    </div>
  </div>
</template>
<script>
import { QryAccountDetail } from '@/api/user'
import waves from '@/directive/waves' // 水波纹指令
import { parseTime } from '@/utils'

export default {
  name: 'WithdrawRecord',
  directives: {
    waves
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        type: 'ext',
        userName: null
      }
    }
  },
  computed: {
  },
  created() {
    this.getList()
  },
  mounted() {
    this.$nextTick(function() {

    })
  },
  methods: {
    getList() {
      QryAccountDetail(this.listQuery).then(response => {
        this.list = response.LsList
        this.total = response.TotalRows
        this.listLoading = false
      })
    },
    handleChange() {
      for (const key in this.listQuery) {
        if (!this.listQuery[key]) {
          this.listQuery[key] = null
        }
      }
    },
    handleFilter() {
      this.listQuery.pageIndex = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getList()
    },
    resetTemp() {
      this.listQuery = {
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize,
        startTime: null,
        endTime: null,
        type: 'ext',
        userName: null
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j])
        } else {
          return v[j]
        }
      }))
    }
  }
}
</script>
